module.exports = __webpack_public_path__ + "media/images/log/log-height-856f3e61f0a5deb0b2a1f034b0030f7f.svg";